//  import { resetRouter } from '@/router'
//  import useTabsStore from '@/stores/modules/multipleTabs'
import useUserStore from '../stores/modules/user'
import cache from './cache'
import configs from '@/config'
const TOKEN_KEY = configs.token_key

export function getToken () {
    return cache.get(TOKEN_KEY)
}

export function clearAuthInfo () {
    const userStore = useUserStore()
    // const tabsStore = useTabsStore()
    userStore.resetState()
    // tabsStore.resetState()
    console.log(TOKEN_KEY)
    cache.remove(TOKEN_KEY)
    //  resetRouter()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js